export const COOKIE_CONSENT_STORAGE_KEY = 'salovare-cookie-consent';

export const COOKIE_CONSENT_POLICY_VERSION = '2';

export const CookieConsentCategories = {
  NECESSARY: 'necessary',
  FUNCTIONAL: 'functional',
  THIRD_PARTY: 'thirdParty',
  ADVERTISING: 'advertising',
};
